import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { AbilityServiceSignal } from '@casl/angular';
import { TranslatePipe } from '@ngx-translate/core';
import { RoleAction, RolePermissionSubject } from '@wilson/interfaces';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { QualificationExportService } from '../../../service/qualification-export.service';

@Component({
  selector: 'wilson-complementary-certificate-export-button',
  imports: [TranslatePipe, NzButtonModule, NzTooltipModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    @let hasQualificationReadPermission =
      can(RoleAction.Read, RolePermissionSubject.UserQualificationV2);
    <button
      nz-button
      (click)="exportComplementaryCertificate()"
      [disabled]="!hasQualificationReadPermission"
      nz-tooltip
      [nzTooltipTitle]="'general.no_permissions' | translate"
      [nzTooltipTrigger]="!hasQualificationReadPermission ? 'hover' : null"
    >
      {{ 'page.qualifications.export_complementary_certificate' | translate }}
    </button>
  `,
})
export class ComplementaryCertificateExportButtonComponent {
  private exportService = inject(QualificationExportService);

  protected can = inject(AbilityServiceSignal).can;
  public readonly RoleAction = RoleAction;
  public readonly RolePermissionSubject = RolePermissionSubject;

  exportComplementaryCertificate(): void {
    this.exportService.exportComplementaryCertificate();
  }
}
